var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('button',{attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.addUnit.apply(null, arguments)}}},[_vm._v("Add Units")])])}
var staticRenderFns = []

export { render, staticRenderFns }